// 完整版下使用支持按照某个字段进行分组的 dodge
var mix = require('@antv/util/lib/mix');

var Adjust = require('./base');

var Dodge = require('./dodge');

var Stack = require('./stack');

var AdjustMixin = require('./mixin/adjust');

var DodgeMixin = require('./mixin/dodge');

var StackMixin = require('./mixin/stack');

mix(Adjust.prototype, AdjustMixin);
mix(Dodge.prototype, AdjustMixin, DodgeMixin);
mix(Stack.prototype, StackMixin);
Adjust.Jitter = require('./jitter');
Adjust.Symmetric = require('./symmetric');
Adjust.Dodge = Dodge;
Adjust.Stack = Stack;
module.exports = Adjust;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_adjust@0.1.1@@antv/adjust/lib/index.js
// module id = 307
// module chunks = 0 1 2